import { useCallback, useState } from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';

import { selectUserConnected, selectUserLastSessionSettledBets } from '../../../selectors/user/userPrimary.selector';
import { storage } from '../../../utils';
import isHome from '../../../utils/routes/isHome';
import { GiftRaceStorageKeyTypes, getGiftRaceStorageKey } from '../constants/storage';
import { selectGRGlobalRaceId } from '../selectors/global/globalPrimary.selector';
import { selectIsGREnabledAndNotForbidden } from '../selectors/runtime.selector';

const useGRWelcomeAnimationUtils = (): [boolean, (value: boolean) => void] => {
  const raceId = useSelector(selectGRGlobalRaceId);
  const isConnected = useSelector(selectUserConnected);
  const lastSessionSettledBets = useSelector(selectUserLastSessionSettledBets);
  const location = useLocation();
  const isHomePage = isHome(location.pathname);
  const key = raceId ? getGiftRaceStorageKey(raceId, GiftRaceStorageKeyTypes.HOME_ANIMATION_BEEN_VIEWED) : null;
  const hasBeenViewed = key ? storage.localStorage.load(key) : false;
  const [viewed, setViewed] = useState(hasBeenViewed);

  const isGrEnabled = useSelector(selectIsGREnabledAndNotForbidden);
  const shouldShow = !!(
    raceId &&
    isHomePage &&
    isConnected &&
    !lastSessionSettledBets?.length &&
    !viewed &&
    !hasBeenViewed &&
    isGrEnabled
  );

  const setHasBeenViewed = useCallback(
    (value: boolean) => {
      if (key) {
        storage.localStorage.save(key, value);
        setViewed(true);
      }
    },
    [key],
  );

  return [shouldShow, setHasBeenViewed];
};

export default useGRWelcomeAnimationUtils;
